
export default function valueIsNullOrUndefined(value1:any,value2:any){
  if(value1 === null || value1 === undefined || value1 == '' || value1 == 0)
    return value2;
  return value1;
}